import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../environments/environment';
import {LoginPage} from "../../pages/login/login.component";
import {AuthControllerService} from "../../../services/auth-controller/auth-controller.service";
import {Token} from "../../../models/token";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class HeaderWidget implements OnInit {

    serviceId: string;
    partALink: string;
    showNotVerifiedMessage: boolean;
    verificationMessage: string;

    constructor(private activatedRoute: ActivatedRoute,
                public translate: TranslateService,
                private authService: AuthControllerService,
                private router: Router) {
        translate.addLangs(environment.translate.languages);
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.serviceId = params['serviceId'];
        });

		this.initAfterUserLoad = this.initAfterUserLoad.bind(this);
		this.initAfterUserLoad();
		this.authService.subscribeForTokenChange(this.initAfterUserLoad);
	}

	ngOnDestroy(): void {
		this.authService.unsubscribe(this.initAfterUserLoad);
	}

    initAfterUserLoad() {
        if (this.authService.isLogged()) {
            this.partALink = environment.partAUrl + 'site-login-token?token=' + this.authService.savedToken();
            const userVerified = this.authService.isUserVerified();
            const userEmailVerified = this.authService.isUserEmailVerified();
            this.showNotVerifiedMessage = HeaderWidget.showVerificationWarning(userVerified, userEmailVerified);
            this.verificationMessage = HeaderWidget.getVerificationMessage(userVerified,
                userEmailVerified);
            this.translate.use(this.translate.currentLang || this.authService.loggedUser().lang || environment.translate.defaultLanguage);
        }
    }

    public static showVerificationWarning(userVerified: boolean, userEmailVerified: boolean) {
        return !userVerified || !userEmailVerified;
    }

    public static getVerificationMessage(isUserVerified, isUserEmailVerified){
        if (!isUserVerified && !isUserEmailVerified) {
            return 'Email and user not verified';
        }
        if (!isUserVerified) {
            return 'User not yet verified';
        }
        return 'Email not yet verified';
    }

    onLogout() {
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    getName(): string {
        const savedTokenValid = this.authService.isSavedTokenValid();
        if(!savedTokenValid){
            return "not_logged_in";
        }
        const user = this.authService.loggedUser();
        return user.fname + ' ' + user.lname;
    }

}
